import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Modal, Icon, NewButton, H2 } from '../../../../../components';
import { InviteUserForm } from '../InviteUserForm';

const InviteUserModalHeader = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const InviteUserModalBody = styled.div`
  flex: 1;
  overflow: auto;
`;

const InviteUserModal = ({ onSubmit, roles, usedEmailsList }) => (
  <Modal size='md' bodyStyle={{ padding: 0 }}>
    {(close) => (
      <>
        <InviteUserModalHeader>
          <H2>Invite people</H2>
          <NewButton tertiary onClick={close}>
            <Icon name='close' color='var(--content-body)' />
          </NewButton>
        </InviteUserModalHeader>
        <InviteUserModalBody>
          <InviteUserForm
            onSubmit={(data) => {
              onSubmit(data);
              close();
            }}
            roles={roles}
            usedEmailsList={usedEmailsList}
          />
        </InviteUserModalBody>
      </>
    )}
  </Modal>
);

InviteUserModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string
    })
  ).isRequired,
  usedEmailsList: PropTypes.arrayOf(PropTypes.string).isRequired
};

export { InviteUserModal };
